import { ButtonV4 } from '@/components/v4/atoms/button/button'
import { FOOTER_CTA } from '../footer-data'
import s from './footer-cta-strip.module.scss'

export const FooterCtaStrip = () => {
  return (
    <div className={s.container}>
      <div className={s.inner}>
        <p className={s.heading}>{FOOTER_CTA.heading}</p>
        <div className={s.buttons}>
          {FOOTER_CTA.buttons.map((button) => (
            <ButtonV4
              key={button.href}
              href={button.href}
              variant="dark"
              className={s.button}
            >
              {button.label}
            </ButtonV4>
          ))}
        </div>
      </div>
    </div>
  )
}
